var React = require('react');

function Section3TopMiddleInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"12","cy":"32","r":"12","fill":"#F58C8C","key":0}),React.createElement("circle",{"cx":"192.5","cy":"28.5","r":"28.5","fill":"#FFCCF3","key":1}),React.createElement("polygon",{"fill":"#E7F5FF","points":"150 65.049 211.039 40 299.355 96.041","key":2})]));
}

Section3TopMiddleInline.defaultProps = {"width":"300","height":"96","viewBox":"0 0 300 96"};

module.exports = Section3TopMiddleInline;

Section3TopMiddleInline.default = Section3TopMiddleInline;
